export * from './lib/drag-bar.module';
export * from './lib/drag-bar/drag-bar.component';
